module.exports = __webpack_public_path__ + "img/rebg.f23b1176.png";